import * as React from 'react'

import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'

import { PURE_BACKOFFICE_PATHS, Screen } from './constants'
import { useMakeLinkClickHandler } from './hooks/makeLinkClickHandler'

export function FansCounter({
  project,
  screen,
}: {
  project: api.Project
  screen: Screen
}): React.ReactElement<any> | null {
  const clickHandler = useMakeLinkClickHandler({
    screen,
    project,
    href: `${PURE_BACKOFFICE_PATHS.PRE_LAUNCH}#pre-launch-section`,
  })

  return (
    <FansCountWrapper>
      {project.fans_prelaunch_count === 0 ? (
        <>
          <plume.styles.copy.S.regular>
            {t('Collect email addresses of future backers on your pre-launch page 👇')}
          </plume.styles.copy.S.regular>

          <plume.Link
            tinted
            href={`/projects/${project.id}/backoffice${PURE_BACKOFFICE_PATHS.PRE_LAUNCH}#pre-launch-section`}
            onClick={clickHandler.onClick}
          >
            {t('Set up')}
            <plume.glyphs.stroke.ArrowRight size={18} />
          </plume.Link>
        </>
      ) : (
        <>
          <plume.styles.heading.L>{project.fans_prelaunch_count}</plume.styles.heading.L>
          <plume.styles.copy.S.regular>{t('pre-registered fans')}</plume.styles.copy.S.regular>
          <plume.Link
            tinted
            href={`/projects/${project.id}/backoffice${PURE_BACKOFFICE_PATHS.PRE_LAUNCH}#pre-launch-section`}
            onClick={clickHandler.onClick}
          >
            {t('Share')}
            <plume.glyphs.stroke.ArrowRight size={18} />
          </plume.Link>
        </>
      )}
    </FansCountWrapper>
  )
}

const FansCountWrapper = styled.div`
  align-items: center;
  box-shadow: ${plume.EFFECTS.SHADOW_1};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 20px 12px;

  ${plume.styles.heading.L} {
    padding-bottom: 5px;
  }

  ${plume.styles.copy.S.regular} {
    text-align: center;
  }

  ${plume.Link} {
    display: flex;
    align-items: center;
    margin: 0 auto;
    gap: 8px;
    padding-top: 16px;
  }
`
